'use client';

import React from 'react';
import { Loader2 } from 'lucide-react';

interface ProgressSectionProps {
  current: number;
  total: number;
  isProcessing: boolean;
}

export default function ProgressSection({ current, total, isProcessing }: ProgressSectionProps) {
  const pct = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div className="bg-card border border-border rounded-xl px-6 py-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          {isProcessing && <Loader2 size={14} className="animate-spin text-primary" />}
          <span className="text-sm font-medium text-foreground">
            {isProcessing ? 'A processar...' : 'Processamento concluído'}
          </span>
        </div>
        <span className="text-sm font-semibold text-tabular text-foreground">
          {current} / {total}
          <span className="text-muted-foreground font-normal ml-1 text-xs">PDFs</span>
        </span>
      </div>

      {/* Progress bar track */}
      <div className="h-2.5 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-primary rounded-full transition-all duration-300 ease-out"
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={current}
          aria-valuemin={0}
          aria-valuemax={total}
          aria-label={`${pct}% processado`}
        />
      </div>

      <p className="text-xs text-muted-foreground mt-1.5 text-tabular">
        {pct}% concluído
        {total > 0 && current < total && isProcessing && (
          <span className="ml-2">— {total - current} restante{total - current !== 1 ? 's' : ''}</span>
        )}
      </p>
    </div>
  );
}